import React from 'react'
import { Link } from 'react-router-dom';
import "./Styles.css";

function Footer() {
  return (

    <>

    <div className=" footer-container" >
        <div className="footer-app ">

            <ul className="">
                
                <li> <Link to="/about" > About </Link> </li>
                <li> <Link to="/aura-muse" > Aura Muse </Link> </li>
                <li> <Link to="/himalayan-voyages" > Himalayan Voyages </Link> </li>
                <li> <Link to="/abled-voyages" > Abled Voyages </Link> </li>
                <li> <Link to="/sustainability" > Sustainability </Link> </li>
                <li> <Link to="/be-responsible" > Be-responsible </Link> </li>
                <li> <Link to="/terms-and-conditions" > Terms & Conditions </Link> </li>
                <li> <Link to="/privacy-policy" > Privacy Policy </Link> </li>
                
                
                {/* <li>  &#169; Aura Voyages 2023 </li> */}

                
                

            </ul>      

            
        </div>

        
    </div>
    <div className='reference-humanthing'> 
          <a  href="https://www.humanthing.in/" 
        target="_blank" rel="noopener noreferrer">
        Branding & Design - human thing consulting  </a> 
    </div>

    </>

  )
}

export default Footer
